import { Controller } from "stimulus"
import moment from "moment-timezone"
window.moment = moment

export default class extends Controller {
  static targets = ["datePastError", "dateTooSoonError", "submitButton"]

  populate(event) {
    const { orderId, timezone } = event.currentTarget.dataset
    document.getElementById("order_id").value = orderId
    this.setChosenTimezone(timezone)
  }

  confirmPostpone(event) {
    if (!window.confirm(event.currentTarget.dataset.confirmMessage)) {
      event.preventDefault()
    }
  }

  changeTimezone(event) {
    this.setChosenTimezone(event.currentTarget.value)
  }

  setChosenTimezone(value) {
    document.getElementById("order_time_zone").value = value
    document.getElementById("timezone_hint").textContent = value
  }

  checkDate() {
    const timezone = document.getElementById("order_time_zone").value
    const selectedDate = moment.tz({
      year: Number(document.getElementById("order_event_date_1i").value),
      month: Number(document.getElementById("order_event_date_2i").value) - 1,
      date: Number(document.getElementById("order_event_date_3i").value),
      hour: Number(document.getElementById("order_event_date_4i").value),
      minute: Number(document.getElementById("order_event_date_5i").value)
    }, timezone)

    const now = moment.tz(timezone)
    const datePast = now.isAfter(selectedDate, "day")
    const dateTooSoon = now.clone().add(48, "hours").isAfter(selectedDate, "hour") && !datePast

    this.datePastErrorTarget.classList.toggle("hidden", !datePast)
    this.dateTooSoonErrorTarget.classList.toggle("hidden", !dateTooSoon)

    this.submitButtonTarget.disabled = datePast || dateTooSoon
  }
}
